import { isDate, isNumber, isString } from "lodash";
import { InputValidation } from "@/helpers/InputValidation";
class Validator {
  static cpf(document: string): boolean{
    if (/^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(document) || /^\d{11}$/.test(document)){
      return Validator.validateDocument(document);
    } else {
      return false;
    }
  }

  static validateDocument(document : any): boolean {
    if (document.length != 14) {
      return false;
    }

    let cpf = document.trim();
    let v1 = 0;
    let v2 = 0;
    let aux = false;

    cpf = cpf.replace(/\./g, '');
    cpf = cpf.replace('-', '');
    cpf = cpf.split('');

    for (let i = 1; cpf.length > i; i++) {
        if (cpf[i - 1] != cpf[i]) {
            aux = true;
        }
    }
    if (aux == false) {
        return false;
    }
    for (let i = 0, p = 10; (cpf.length - 2) > i; i++, p--) {
        v1 += cpf[i] * p;
    }
    v1 = ((v1 * 10) % 11);

    if (v1 == 10) {
        v1 = 0;
    }
    if (v1 != cpf[9]) {
        return false;
    }
    for (let i = 0, p = 11; (cpf.length - 1) > i; i++, p--) {
        v2 += cpf[i] * p;
    }
    v2 = ((v2 * 10) % 11);

    if (v2 == 10) {
        v2 = 0;
    }
    if (v2 != cpf[10]) {
        return false;
    }
    return true;
    }

  static date(value: string): boolean {
    return (
      /^\d{4}-\d{2}-\d{2}$/.test(value) &&
      isDate(new Date(value)) &&
      new Date(value).getFullYear() > new Date().getFullYear() - 100 &&
      new Date(value).getFullYear() <= new Date().getFullYear()
    );
  }

  static dateBR(value: string): boolean {
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
      const arr = value.split("/");
      const dateUS = `${arr[2]}-${arr[1]}-${arr[0]}`;
      return Validator.date(dateUS);
    }

    return false;
  }

  static getAge(dateString: string): number {
    const today = new Date();
    const birthDate = new Date(dateString);
    let age = today.getTime() - birthDate.getTime();
    const month = today.getMonth() - birthDate.getMonth();
    if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  static minAgeDateBR(value: string, minAge: number): boolean {
    if (Validator.dateBR(value)) {
      const arr = value.split("/");
      const dateUS = `${arr[2]}-${arr[1]}-${arr[0]}`;
      return Validator.getAge(dateUS) >= minAge;
    }

    return false;
  }

  static email(value: string): boolean {
    return /^[a-z0-9][a-z0-9_\-.+]*[a-z0-9]@([a-z0-9][a-z0-9_\-+]*[a-z0-9])(\.[a-z0-9][a-z0-9_\-+]*[a-z0-9]){1,3}/.test(
      value
    );
  }

  static maxLength(value: string, length: number): boolean {
    return isString(value) && value.length <= length;
  }

  static maxValue(value: string, maxValue: number): boolean {
    return Validator.numeric(value) && parseFloat(value) <= maxValue;
  }

  static minLength(value: string, length: number): boolean {
    return isString(value) && value.length >= length;
  }

  static minValue(value: string, minValue: number): boolean {
    return isNumber(value) && value >= minValue;
  }

  static numeric(value: string): boolean {
    return isNumber(value);
  }

  static phone(value: string): boolean {
    if(typeof value === "undefined"){
      return false;
    }
    return isString(value) && /^\d{10,11}$/.test(value.replace(/\D/g, "")) && /^((1[1-9])|([2-9][0-9]))((3[0-9]{3}[0-9]{4})|(9[0-9]{3}[0-9]{5}))$/.test(value.replace(/\D/g, ""));
  }

  static required(value: string): boolean {
    return isString(value) && value.length > 0;
  }

  static validAge(value: number): boolean {
    return value >= 0 && value <= 120 ? true : false;
  }

  static run(value: any, method: string, params: any = null): boolean {
    switch (method) {
      case "validCpf":
        return Validator.cpf(value);
      case "date":
        return Validator.date(value);
      case "dateBR":
        return Validator.dateBR(value);
      case "validBirthDate":
        return Validator.minAgeDateBR(value, params);
      case "validEmail":
        return Validator.email(value);
      case "maxLength":
        return Validator.maxLength(value, params);
      case "maxValue":
        return Validator.maxValue(value, params);
      case "minLength":
        return Validator.minLength(value, params);
      case "minValue":
        return Validator.minValue(value, params);
      case "numeric":
        return Validator.numeric(value);
      case "validPhone":
        return Validator.phone(value);
      case "requiredField": 
        return Validator.required(value);
      case "validAge":
        return Validator.validAge(value);
    }

    return false;
  }

  static validateForm(
    $refs: any,
    showErrors = true,
    fieldsRefKey = "form-"
  ): boolean {
    let isValidForm = true;
    Object.keys($refs).forEach((el) => {
      if (el.includes(fieldsRefKey)) {
        const input: any = $refs[el];
        if (
          input.required &&
          input != null &&
          !InputValidation.isValidInput(showErrors, input)
        ) {
          isValidForm = false;
        }
      }
    });
    return isValidForm;
  }
}

export { Validator };
